module.exports = __webpack_public_path__ + "static/media/western.7468dc58.svg";